import React from 'react';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import ShortText from '@material-ui/icons/ShortText';
import Pin from '@material-ui/icons/NotListedLocation';
import Map from '@material-ui/icons/Map';
import Business from '@material-ui/icons/Business';
// core components
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { REFERRER_DETAIL_INFO_PATH } from 'constants/paths';
import {
  POSTCODE_LENGTH,
  ADDRESS_LINE_MAX,
  ADDRESS_LINE_MIN,
  SUBURB_MAX,
  ORGANISATION_MIN,
  ORGANISATION_MAX
} from 'constants/inputBounds';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import customSelectStyle from 'assets/jss/material-dashboard-pro-react/customSelectStyle.jsx';
import customCheckboxRadioSwitch from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx';
import familyImage from '../../../../assets/images/Gfx-More-Information.svg';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import InputAdornment from '@material-ui/core/InputAdornment';
import STATES from 'constants/states';
import InfoArea from 'components/InfoArea/InfoArea.jsx';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';


const style = {
  infoText: {
    fontWeight: '300',
    margin: '10px 0 30px',
    textAlign: 'center'
  },
  inputAdornmentIcon: {
    color: '#555'
  },
  choice: {
    textAlign: 'center',
    cursor: 'pointer',
    marginTop: '20px'
  },
  flatImage: {
    width: '80%',
    maxWidth: '450px',
    marginTop: '3rem',
    height: 'auto',
    margin: 'auto',
    marginLeft: '12%'
  },
  textCenterH1: {
    textAlign: 'center',
    maxWidth: 300,
    margin: 'auto',
    marginBottom: 45
  },
  textCenterH1Right: {
    textAlign: 'center',
    maxWidth: 300,
    margin: 'auto',
    marginBottom: 65
  },
  textCenterP: {
    textAlign: 'center',
    maxWidth: 260,
    margin: 'auto'
  },
  anchorButton: {
    textDecoration: 'none',
    alignSelf: 'center',
    padding: 0,
    textTransform: 'none',
    minHeight: 0,
    marginTop: -1,
    minWidth: 37,
    color: '#2b81e0'
  },
  girdItemPadding: {
    paddingLeft: 60,
    paddingRight: 60
  },
  ...customSelectStyle,
  ...customCheckboxRadioSwitch
};

class Step2 extends React.Component {
  constructor(props) {
    super(props);
    const organisations = props.organisations;
    const orgDetails = organisations.find(e => e.name === props.organisation);

    this.state = {
      organisation: props.organisation?props.organisation:'',
      addressLine: orgDetails?(orgDetails.addressLine?orgDetails.addressLine:''):'',
      //addressLine2: '',
      suburb: orgDetails?(orgDetails.suburb?orgDetails.suburb:''):'',
      state: orgDetails?(orgDetails.state?orgDetails.state:''):'',
      postcode: orgDetails?(orgDetails.postcode?orgDetails.postcode:''):'',
      addressLineState: '',
      //addressLine2State: '',
      suburbState: '',
      stateState: '',
      postcodeState: '',
    };
  }
  sendState() {
    return this.state;
  }
  handleSimple = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  // Verify Correct Length of custom input
  verifyLength(value, minLength, maxLength) {
    if (value.length >= minLength && value.length <= maxLength) {
      return true;
    }
    return false;
  }

  // Verify Correctly that input is made of digits only
  verifyDigit(value) {
    if (isNaN(value)) {
      return false;
    }
    return true;
  }

  change(event, stateName, type, stateNameEqualTo, stateNameMax) {
    switch (type) {
      // Checking postcode only tbh lol
      case 'digit':
        if (
          this.verifyDigit(event.target.value) &&
          this.verifyLength(event.target.value, stateNameEqualTo, stateNameMax)
        ) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        break;
      case 'length':
        if (
          this.verifyLength(event.target.value, stateNameEqualTo, stateNameMax)
        ) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        break;
      default:
        break;
    }
    this.setState({ [stateName]: event.target.value });
  }

  isValidated() {
    return true;
  }
  camelize(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
        return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
      })
      .replace(/\s+/g, '');
  }
  createYearsOptions = (classes, start = 3, end = 10, stepSize = 1) => {
    let years = [];

    // Outer loop to create parent
    for (let i = start; i < end; i += stepSize) {
      //Create the parent and add the children
      years.push(
        <MenuItem
          key={i}
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected
          }}
          value={i.toString()}
        >
          {i} Years
        </MenuItem>
      );
    }
    return years;
  };
  createStateDropdowns = classes => {
    let options = [];
    // Outer loop to create parent
    Array.prototype.forEach.call(STATES, state => {
      //Create the parent and add the children
      options.push(
        <MenuItem
          key={this.camelize(state.replace(/["'()]/g, ''))}
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected
          }}
          value={this.camelize(state.replace(/["'()]/g, ''))}
        >
          {state}
        </MenuItem>
      );
    });
    return options;
  };

  render() {
    const { classes } = this.props;
    const { organisation } = this.props;
    const { organisations } = this.props;
    return (
      <GridContainer justify='center'>
        <GridItem xs={12} sm={6}>
          <h1 className={classes.textCenterH1}>Referrer Program {organisation}</h1>
          <p className={classes.textCenterP}>
            A quick, simple and easy process to refer your clients. See more
            details
            <Button
              className={classes.anchorButton}
              component={Link}
              to={REFERRER_DETAIL_INFO_PATH}
            >
              here
            </Button>
            .
          </p>
          <img className={classes.flatImage} src={familyImage} alt='' />
        </GridItem>
        <GridItem xs={12} sm={6} className={classes.girdItemPadding}>
          {!organisation &&
          <h1 className={classes.textCenterH1Right}>Your Details</h1>
          }
          {organisation &&
            <div>
          <h1 className={classes.textCenterH1Right}>Company Details</h1>
            <InfoArea
              title={organisation}
              description={this.state.addressLine + ' ' + this.state.postcode + ' ' + this.state.state}
              icon={SupervisorAccountIcon}
              iconColor="primary"
            />
          </div>
          }
          {!organisation &&
          <CustomInput
            success={this.state.organisationState === 'success'}
            error={this.state.organisationState === 'error'}
            labelText={
              <span>
                Name of organisation <small>(required)</small>
              </span>
            }
            id='organisation'
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event =>
                this.change(
                  event,
                  'organisation',
                  'length',
                  ORGANISATION_MIN,
                  ORGANISATION_MAX
                ),
              startAdornment: (
                <InputAdornment
                  position='start'
                  className={classes.inputAdornment}
                >
                  <Business className={classes.inputAdornmentIcon} />
                </InputAdornment>
              )
            }}
          />}
          {!organisation &&
          <CustomInput
            success={this.state.addressLineState === 'success'}
            error={this.state.addressLineState === 'error'}
            labelText={
              <span>
                Address line <small>(required)</small>
              </span>
            }
            id='addressLine'
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event =>
                this.change(
                  event,
                  'addressLine',
                  'length',
                  ADDRESS_LINE_MIN,
                  ADDRESS_LINE_MAX
                ),
              startAdornment: (
                <InputAdornment
                  position='start'
                  className={classes.inputAdornment}
                >
                  <ShortText className={classes.inputAdornmentIcon} />
                </InputAdornment>
              )
            }}
          />}
          {/* <CustomInput
            success={this.state.addressLine2State === 'success'}
            error={this.state.addressLine2State === 'error'}
            labelText={
              <span>
                Address line 2 <small>(required)</small>
              </span>
            }
            id="addressLine2"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event => this.change(event, 'addressLine2', 'length', ADDRESS_LINE_MIN, ADDRESS_LINE_MAX),
              startAdornment: (
                <InputAdornment position="start" className={classes.inputAdornment}>
                  <ShortText className={classes.inputAdornmentIcon} />
                </InputAdornment>
              )
            }}
          /> */}
          {!organisation &&
          <CustomInput
            success={this.state.suburbState === 'success'}
            error={this.state.suburbState === 'error'}
            labelText={
              <span>
                Suburb <small>(required)</small>
              </span>
            }
            id='suburb'
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              onChange: event =>
                this.change(event, 'suburb', 'length', 0, SUBURB_MAX),
              startAdornment: (
                <InputAdornment
                  position='start'
                  className={classes.inputAdornment}
                >
                  <Pin className={classes.inputAdornmentIcon} />
                </InputAdornment>
              )
            }}
          />}
          {!organisation &&
          <GridContainer justify='center'>
            <GridItem xs={12} sm={6}>
              <FormControl fullWidth className={classes.selectFormControl}>
                <InputLabel htmlFor='state' className={classes.selectLabel}>
                  State
                </InputLabel>
                <Select
                  MenuProps={{
                    className: classes.selectMenu
                  }}
                  classes={{
                    select: classes.select
                  }}
                  value={this.state.state}
                  onChange={this.handleSimple}
                  inputProps={{
                    name: 'state',
                    id: 'state'
                  }}
                >
                  <MenuItem
                    disabled
                    classes={{
                      root: classes.selectMenuItem
                    }}
                  >
                    State
                  </MenuItem>
                  {this.createStateDropdowns(classes)}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={6}>
              <CustomInput
                success={this.state.postcodeState === 'success'}
                error={this.state.postcodeState === 'error'}
                labelText={
                  <span>
                    Postcode <small>(required)</small>
                  </span>
                }
                id='postcode'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: event =>
                    this.change(
                      event,
                      'postcode',
                      'digit',
                      POSTCODE_LENGTH,
                      POSTCODE_LENGTH
                    ),
                  startAdornment: (
                    <InputAdornment
                      position='start'
                      className={classes.inputAdornment}
                    >
                      <Map className={classes.inputAdornmentIcon} />
                    </InputAdornment>
                  )
                }}
              />
            </GridItem>
          </GridContainer>
        }
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(style)(Step2);
